import { Masks } from "@hooks/functions/Masks/Masks";
import React, { useState } from "react";

import { FiEye, FiEyeOff } from "react-icons/fi";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  animated?: boolean;
  mask?: "phone" | "cpf" | "cnpj" | "cep" | "data";
  register?: any;
  icon?: any;
  errorMessage?: string;
}

const masks = new Masks();

export function InputGroup({
  label,
  animated,
  register,
  mask,
  type,
  placeholder,
  icon,
  errorMessage,
  ...rest
}: IProps) {
  const [showPassword, setShowPassword] = useState(false);

  const maskObj = {
    phone: masks.phone,
    cpf: masks.cpf,
    cnpj: masks.cnpj,
    cep: masks.postalCode,
    data: masks.date,
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (mask && maskObj[mask]) {
      e.target.value = maskObj[mask](e.target.value);
    }

    register?.onChange?.(e);
  };

  return (
    <>
      {animated && (
        <div className="input-group mb-3">
          <div className="form-floating flex-grow-1">
            <input
              className={`form-control ${errorMessage ? "is-invalid" : ""}`}
              placeholder={placeholder}
              type={
                type === "password" && showPassword ? "text" : (type ?? "text")
              }
              {...register}
              {...rest}
              onChange={handleInputChange}
            />
            <label>{label}</label>
          </div>
          {type === "password" && (
            <button
              type="button"
              className="border-0"
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            >
              {showPassword ? <FiEye /> : <FiEyeOff />}
            </button>
          )}

          {type !== "password" && (
            <span className="input-group-text">{icon}</span>
          )}

          {errorMessage && (
            <div className="invalid-feedback">{errorMessage}</div>
          )}
        </div>
      )}

      {!animated && (
        <div>
          {label && <label className="form-label text-white">{label}</label>}
          <div className={`input-group mb-3 input-${type}`}>
            <input
              className={`form-control ${errorMessage ? "is-invalid" : ""}`}
              placeholder={placeholder}
              type={
                type === "password" && showPassword ? "text" : (type ?? "text")
              }
              {...register}
              {...rest}
              onChange={handleInputChange}
            />

            {type === "password" && (
              <button
                type="button"
                className="border-0 btn btn-white"
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              >
                {showPassword ? <FiEye /> : <FiEyeOff />}
              </button>
            )}

            {type !== "password" && icon && (
              <span className="input-group-text">{icon}</span>
            )}

            {errorMessage && (
              <div className="invalid-feedback">{errorMessage}</div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
